"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFRAME_ERRORS = void 0;
exports.IFRAME_ERRORS = {
    BUILD_SOURCE: 'iframe_build_source_error',
    LOAD: 'iframe_load_error',
};
//# sourceMappingURL=iframe-errors.js.map